module.exports = __webpack_public_path__ + "img/galka.b977f3a6.svg";